var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinshiweidang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4752"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631280",
    x: 0.5,
    y: 2.6908,
    width: 15,
    height: 4.16923,
    fill: "#FFC759",
    fillOpacity: 0.7,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 17",
    x1: 2.43408,
    y1: 7.36005,
    x2: 2.43408,
    y2: 13.8093,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 19",
    x1: 13.708,
    y1: 7.36005,
    x2: 13.708,
    y2: 13.8093,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 18",
    x1: 4.30762,
    y1: 14.3093,
    x2: 0.369156,
    y2: 14.3093,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 20",
    x1: 15.5815,
    y1: 14.3093,
    x2: 11.6431,
    y2: 14.3093,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 21",
    x1: 2.33838,
    y1: 10.4209,
    x2: 13.6122,
    y2: 10.4209,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 22",
    x1: 0.416466,
    y1: 6.72891,
    x2: 4.58834,
    y2: 2.55703,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 23",
    x1: 5.83566,
    y1: 6.76186,
    x2: 9.96847,
    y2: 2.62905,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 24",
    x1: 10.771,
    y1: 6.79269,
    x2: 14.9671,
    y2: 2.59652,
    stroke: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinshiweidang);
export default __webpack_public_path__ + "static/media/linshiweidang.faedfdee4d0c01ddda8c7e9f05a91308.svg";
export { ForwardRef as ReactComponent };